import { ComponentVersions_3_0 } from 'constants/uxVersions'
import { Button, ComponentVersionsInherit, FileQuestionIcon, styled } from 'opensolar-ui'
import Notice from 'projectSections/sections/manage3/common/Notice'
import { useTranslate } from 'ra-core'
import { useHistory } from 'react-router-dom'

const ButtonWrapper = styled('div', { name: 'buttonWrapper' })({
  marginTop: '16px',
})

const SubtextWrapper = styled('span', { name: 'SubtextWrapper' })(({ theme }) => ({
  color: theme.palette.grey[500],
  maxWidth: 650,
  lineHeight: '20px',
}))

export const NotFoundVersioned = () => {
  const translate = useTranslate()
  const history = useHistory()

  return (
    <ComponentVersionsInherit versions={ComponentVersions_3_0}>
      <Notice
        icon={<FileQuestionIcon width="26" height="26" color="#4F4D55" strokeWidth="10" />}
        mainText={translate('Page not found')}
        subText={
          <SubtextWrapper>
            {translate(
              'Unfortunately, we were unable to find the page you are looking for. Please check the URL is correct and try again.'
            )}
          </SubtextWrapper>
        }
        cta={
          <ButtonWrapper>
            <Button variant="outlined" onClick={() => history.push('/')} color="primary">
              {translate('Back to home')}
            </Button>
          </ButtonWrapper>
        }
      />
    </ComponentVersionsInherit>
  )
}
